<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-col>
										<v-card-title class="pa-2">{{
											$t('titles.certificateInformations')
										}}</v-card-title>
									</v-col>
									<v-col class="d-flex justify-end">
										<v-btn
											v-if="inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row wrap>
									<v-col cols="12">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="certificate.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="certificate.name"
												:errorBorder="!certificateValidation.name"
												:label="'* ' + $t('fields.name')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:disabled="certificate.unlimited_validity"
												v-model="certificate.validity"
												:errorBorder="!certificateValidation.validity"
												:label="'* ' + $t('fields.validityMonths')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="certificate.price"
												:precision="2"
												:errorBorder="!certificateValidation.price"
												:label="$t('fields.price')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="certificate.provisions"
												:errorBorder="!certificateValidation.provisions"
												:label="$t('fields.provisions')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="certificate.unlimited_validity"
												:label="$t('fields.unlimitedValidity')"
											></CheckBox>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="certificate.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import TextArea from '../../trinkets/TextArea';
import CheckBox from '../../trinkets/CheckBox';
import Certificate from '../../../models/Certificate';
import NumberField from '../../trinkets/NumberField';

export default {
	name: 'Certificate',
	components: { CheckBox, InputField, NumberField, TextArea },
	data: function () {
		return {
			certificate: new Certificate({ id: this.$route.params.id }),
			certificateValidation: new Certificate({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'certificate',
			lockTimer: null,
		};
	},
	watch: {
		'certificate.unlimited_validity': function (newVal) {
			if (newVal && this.inEditMode) {
				this.certificate.validity = null;
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.certificate.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.certificate.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.certificate.name == '') {
				success = false;
				this.certificateValidation.name = false;
			} else {
				if (this.certificate.name.length > 150) {
					this.certificateValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '150') + '<br />';
				} else {
					this.certificateValidation.name = true;
				}
			}

			if (!this.certificate.validity && !this.certificate.unlimited_validity) {
				success = false;
				this.certificateValidation.validity = false;
			} else {
				if (
					(!this.certificate.unlimited_validity && this.certificate.validity < 1) ||
					this.certificate.validity > 10000
				) {
					this.certificateValidation.validity = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.validity'))
							.replace('%min%', '1')
							.replace('%max%', '10000') + '<br />';
				} else {
					this.certificateValidation.validity = true;
				}
			}

			if (
				this.certificate.provisions != null &&
				this.certificate.provisions != '' &&
				this.certificate.provisions.length > 750
			) {
				this.certificateValidation.provisions = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.provisions'))
						.replace('%min%', '1')
						.replace('%max%', '750') + '<br />';
			} else {
				this.certificateValidation.provisions = true;
			}

			if (this.certificate.price < 0 || this.certificate.price > 100000) {
				this.certificateValidation.price = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.price'))
						.replace('%min%', '0')
						.replace('%max%', '100 000') + '<br />';
			} else {
				this.certificateValidation.price = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.certificate.id != 0) {
					action = 'put';
					addition = '/' + vm.certificate.id;
				}
				this.$APICall(action, 'certificates' + addition, this.certificate, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.certificate.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.certificate.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.certificate.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.certificate.id != 0) {
			this.$APICall('get', 'certificates/' + this.certificate.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.certificate = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.certificates'),
							href: '/#/certificates',
							disabled: false,
						},
						{
							text: vm.certificate.name + ' (' + vm.certificate.id + ')',
							href: '/#/certificates/' + vm.certificate.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.certificates'),
					href: '/#/certificates',
					disabled: false,
				},
				{
					text: this.$t('modules.newCertificate'),
					href: '/#/certificates/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
